// store/modules/ads.js
import axios from "axios";

const state = {
  ads: [],
  ads_total: 0,
  ad_report: [],
  labels: undefined,
  loading: true,
  totals: {},
  table: []
};

const actions = {
  getAds({ commit }, values = {}) {
    const page = values.page || 1;
    const itemsPerPage = values.itemsPerPage || 15;
    const sortBy = Array.isArray(values.sortBy) ? values.sortBy : [];
    const sortDesc = Array.isArray(values.sortDesc) ? values.sortDesc : [];

    // &sort=field1,-field2
    const sort =
      sortBy.length > 0
        ? "&sort=" + sortBy.map((s, i) => (sortDesc[i] ? "-" + s : s)).join(",")
        : "";

    const filters = values.filters || "";

    const url =
      `${process.env.VUE_APP_BACKEND_ROUTE}api/v1/ads` +
      `?page=${page}` +
      `&itemsPerPage=${itemsPerPage}` +
      `${sort}${filters}`;

    return axios.get(url).then(response => {
      commit('setAds', response.data.data);
      commit('setAdsTotal', response.data?.meta?.total || 0);
    });
  },

  getAdReport({ commit, state }, values){
    state.true = false
    return axios
      .get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/ad/report" + (values?.filters || ''))
      .then(response => {
        commit('setAdReport', response.data.data);
      });
  },
};

const mutations = {
  setAds(state, data){ state.ads = data; },
  setAdsTotal(state, total){ state.ads_total = total; },
  setAdReport(state, data){
    const report = data.map(item=>{
      const key = Object.keys(item)[0];
      const value = item[key];
      return { ...value, day: key };
    });
    state.table = report;

    state.ad_report = [
      { name: 'Impresiones', type: 'column', data: report.map(r => r.impressions) },
      { name: 'Clics',       type: 'area',   data: report.map(r => r.clicks) },
      { name: 'Conversiones',type: 'line',   data: report.map(r => (100/r.impressions)*r.clicks) }
    ];

    const sumaImpresiones = state.ad_report[0].data.reduce((a,b)=>a+b,0);
    const sumaClics       = state.ad_report[1].data.reduce((a,b)=>a+b,0);

    state.totals = {
      clicks: sumaClics,
      impressions: sumaImpresiones,
      conversions: sumaImpresiones ? ((100/sumaImpresiones)*sumaClics).toFixed(2) : '0.00'
    };

    state.labels = report.map(r => r.day);
    state.loading = false;
  },
};

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
